module.exports = __webpack_public_path__ + "fonts/BradfordLLWeb-Regular.17a6e7a0.woff2";